module.exports = __webpack_public_path__ + "static/profile-pic-fff7416b7fabc111a53ceb546da74d38.jpg";